import * as React from "react";
import { VingleURL } from "@vingle/wtf-sdk/url";
// component
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import PaddedListItem from "common/components/paddedListItem";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
// styles

const styles = require("./interestItem.scss");

interface IProps {
  interest: Vingle.UserProfile.IUserInterest;
  username: string;
}

class TopInterestItem extends React.PureComponent<IProps> {
  public render() {
    return (
      <PaddedListItem
        leftElement={this.renderLeftElement()}
        rightElement={this.renderRightElement()}
      />
    );
  }

  private readonly renderLeftElement = () => {
    const { username, interest } = this.props;

    return (
      <div className={styles.left}>
        <div className={styles.title}>
          <Link
            to={new VingleURL.UserShowInterestDetail({
              username,
              interest: interest.interest.name,
            }).toString()}
          >
            <IconWrapper
              className={styles.interestMark}
              icon={PACKS.INTEREST_MARK.PROFILE.MY_INTEREST.INTEREST_MARK}
            />
            {interest.interest.name.split(":")[0]}
          </Link>
        </div>
        <div className={styles.summary}>
          <FormattedMessage
            id="interests.boost_summary"
            values={{
              boost_count: (
                <NumberFormatter
                  num={interest.received_actions.boost_count}
                  digits={0}
                />
              ),
            }}
          />
        </div>
      </div>
    );
  };

  private readonly renderRightElement = () => {
    return <div className={styles.right}>{this.props.children}</div>;
  };
}

export default TopInterestItem;
